import {
    ACTIVECART_DRAFTORDER_GET_REQUEST,
    ACTIVECART_BESTCOUPON_GET_REQUEST,
    ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST,
    ACTIVECART_TOGGLE_WIGGLE_EFFECT,
} from '../actionTypes/ActiveCartReminderActionTypes';

const getDraftOrderDetails = () => ({
    type: ACTIVECART_DRAFTORDER_GET_REQUEST,
});

const getBestCouponDetails = () => ({
    type: ACTIVECART_BESTCOUPON_GET_REQUEST,
});

const applyBestCoupon = (couponName) => ({
    type: ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST,
    payload: {
        code: couponName,
        serialNumber: null,
    },
});

const toggleWiggleCart = (payload) => ({
    type: ACTIVECART_TOGGLE_WIGGLE_EFFECT,
    payload,
});

export default {
    getDraftOrderDetails,
    getBestCouponDetails,
    applyBestCoupon,
    toggleWiggleCart,
};
